import './style.scss'
import React from 'react'
import { Flex, Text, tokens } from 'src/componentv2/Base/ui'

export interface TablePaginationProps {
    page: number
    total: number
    pageSize: number
    onPageChange: (page: number) => void
    className?: string
}

export const TablePagination: React.FC<TablePaginationProps> = ({
                                                                    page,
                                                                    total,
                                                                    pageSize,
                                                                    onPageChange,
                                                                    className = '',
                                                                }) => {
    const totalPages = Math.max(1, Math.ceil(total / pageSize))

    return (
        <Flex className={`table-pagination ${className}`} justify="space-between" items="center">
            <Flex gap="1.2">
                <button
                    type="button"
                    className="table-pagination__btn"
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                >
                    Previous
                </button>

                <button
                    type="button"
                    className="table-pagination__btn"
                    disabled={page >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                >
                    Next
                </button>
            </Flex>

            <Text fontSize="1.4" color={tokens.textMuted}>
                Page{' '}
                <Text as="span" fontWeight="600" color={tokens.textDark}>
                    {page}
                </Text>{' '}
                of {totalPages}
            </Text>
        </Flex>
    )
}

export default TablePagination